import React from 'react';

const DateAndTimeIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            stroke='none'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.16679 4.79102C3.89052 4.79102 3.62557 4.90076 3.43022 5.09611C3.23487 5.29146 3.12512 5.55641 3.12512 5.83268V15.8327C3.12512 16.1089 3.23487 16.3739 3.43022 16.5693C3.62557 16.7646 3.89052 16.8743 4.16679 16.8743H9.82929C10.1745 16.8743 10.4543 17.1542 10.4543 17.4993C10.4543 17.8445 10.1745 18.1243 9.82929 18.1243H4.16679C3.559 18.1243 2.97611 17.8829 2.54634 17.4531C2.11656 17.0234 1.87512 16.4405 1.87512 15.8327V5.83268C1.87512 5.22489 2.11656 4.642 2.54634 4.21223C2.97611 3.78246 3.559 3.54102 4.16679 3.54102H14.1668C14.7746 3.54102 15.3575 3.78246 15.7872 4.21223C16.217 4.642 16.4585 5.22489 16.4585 5.83268V9.16602C16.4585 9.51119 16.1786 9.79102 15.8335 9.79102C15.4883 9.79102 15.2085 9.51119 15.2085 9.16602V5.83268C15.2085 5.55642 15.0987 5.29146 14.9034 5.09611C14.708 4.90076 14.4431 4.79102 14.1668 4.79102H4.16679Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.0004 12.291C13.5047 12.291 12.2921 13.5036 12.2921 14.9993C12.2921 16.4951 13.5047 17.7077 15.0004 17.7077C16.4962 17.7077 17.7088 16.4951 17.7088 14.9993C17.7088 13.5036 16.4962 12.291 15.0004 12.291ZM11.0421 14.9993C11.0421 12.8132 12.8143 11.041 15.0004 11.041C17.1866 11.041 18.9588 12.8132 18.9588 14.9993C18.9588 17.1855 17.1866 18.9577 15.0004 18.9577C12.8143 18.9577 11.0421 17.1855 11.0421 14.9993Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.5001 1.875C12.8453 1.875 13.1251 2.15482 13.1251 2.5V5.83333C13.1251 6.17851 12.8453 6.45833 12.5001 6.45833C12.1549 6.45833 11.8751 6.17851 11.8751 5.83333V2.5C11.8751 2.15482 12.1549 1.875 12.5001 1.875Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.83313 1.875C6.17831 1.875 6.45813 2.15482 6.45813 2.5V5.83333C6.45813 6.17851 6.17831 6.45833 5.83313 6.45833C5.48795 6.45833 5.20813 6.17851 5.20813 5.83333V2.5C5.20813 2.15482 5.48795 1.875 5.83313 1.875Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.87512 9.16602C1.87512 8.82084 2.15494 8.54102 2.50012 8.54102H15.8335C16.1786 8.54102 16.4585 8.82084 16.4585 9.16602C16.4585 9.51119 16.1786 9.79102 15.8335 9.79102H2.50012C2.15494 9.79102 1.87512 9.51119 1.87512 9.16602Z'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.0001 13.1211C15.3453 13.1211 15.6251 13.4009 15.6251 13.7461V14.7405L16.2754 15.3908C16.5195 15.6349 16.5195 16.0306 16.2754 16.2747C16.0313 16.5188 15.6356 16.5188 15.3915 16.2747L14.5582 15.4414C14.441 15.3242 14.3751 15.1652 14.3751 14.9994V13.7461C14.3751 13.4009 14.6549 13.1211 15.0001 13.1211Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default DateAndTimeIcon;
